(function () {
    'use strict';
    var controllerId = '4a_pcDocenteAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'docente', 'corsoId', 'opInsert', 'province', 'paesi', 'cndPCMod', 'tProfiloDocenti', 'tTitoloStudio', fn_4a_pcDocenteAdd]);

    function fn_4a_pcDocenteAdd($scope, $uibModalInstance, datacontext, docente, corsoId, opInsert, province, paesi, cndPCMod, tProfiloDocenti, tTitoloStudio) {
        $scope.province = province;
        $scope.paesi = paesi;
        $scope.cndPCMod = cndPCMod;
        $scope.tProfiloDocenti = tProfiloDocenti;
        $scope.tTitoloStudio = tTitoloStudio;
        $scope.comuni = [];
        $scope.validCF = true;
        $scope.checkCF = checkCF;   
        $scope.validPIVA = true;
        $scope.checkPIVA = checkPIVA;

        if (docente) {
            $scope.record = jQuery.extend({}, docente); //Clona oggetto.
            $scope.Title = 'Modifica Docente (ID: ' + $scope.record.Id + ')';
            if (typeof $scope.record.CodiceFiscale != 'undefined' && $scope.record.CodiceFiscale != null && $scope.record.CodiceFiscale.length > 0) {
                checkCF($scope.record.CodiceFiscale);
            }
            if (typeof $scope.record.PartitaIVA != 'undefined' && $scope.record.PartitaIVA != null && $scope.record.PartitaIVA.length > 0) {
                checkPIVA($scope.record.PartitaIVA);
            }
            if ($scope.record.NascProvinciaId > 0) {
                getComuni($scope.record.NascProvinciaId);
            }
            if ($scope.record.NascData != null) {
                $scope.record.NascData = new Date($scope.record.NascData);
            }
        }
        else {
            $scope.Title = 'Nuovo Docente';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CNDCorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;

            $scope.record.TIndirizzoId = 1;
            $scope.record.NascComuneId = '';
            $scope.record.NascPaeseId = 0;


        }      

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            //return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                console.log('iOpened == 1');
                $scope.opened1 = true;
            }

        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                $scope.record.NascData = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";

        

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

        $scope.change_Paesi = function () {
            if ($scope.record.NascPaeseId > 0) {
                $scope.record.NascProvinciaId = 0;
                $scope.record.NascComuneId = 0;
            }
        };

        $scope.change_Comuni = function (idprov) {
            //console.info('change_Comuni()', idprov);
            $scope.record.NascComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            //console.info('getComuni()', idprov);
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.NascProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

        function checkCF(_value) {
            $scope.validCF = true;
            if (typeof _value == 'undefined') return;
            if (_value.length != 16) return;
            $scope.validCF = false;
            return datacontext.validazione_cf(_value, false).then(function (data) {
                return $scope.validCF = data;
            });
        }

        function checkPIVA(_value) {
            $scope.validPIVA = true;
            if (typeof _value == 'undefined') return;
            if (_value.length != 16) return;
            $scope.validPIVA = false;
            return datacontext.validazione_piva(_value).then(function (data) {
                return $scope.validPIVA = data;
            });
        }

    }
})();